import { Box, Icon, Loader, ModalDialogNew, ModBox, Spacer, Text, TextInput } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { useEffect, useState } from 'react'
import { Animated, Platform } from 'react-native'
import { useLazyApiData } from '../../data/store'
import { Routes } from '../../nav/routes'
import { isButtonDisabled, onBlur, onchangeText, onPress } from './Differentiator'
import { useKeyboard } from './keyboardHook'
import { getRefundValid } from './RefundHelpers'
import styles from './styles'

const isIos = Platform.OS === 'ios'
interface KeyboardAwareModalInterface {
  visible: boolean
  hideModal: () => void
  label: string
  totalAmount?: string | number
  route: string
  status?: 'success' | 'pending' | 'rejected' | undefined
  headerText: string
  buttonText: string
  txnId?: string
  handleGenerateQr?: (amount: string) => void
  generateStatus?: boolean
  navigateToSuccess: any
  initiateSingleRefund: any
  showInvoiceId?: boolean
}

const getRefundMessage = (status: string) => {
  if (status === 'SUCCESS') {
    return 'Refunded'
  }
  if (status === 'ACCEPTED') {
    return 'Refunded'
  }
  if (status === 'PENDING') {
    return 'Refund Request Pending'
  }
  if (status === 'PROCESSED') {
    return 'Refund Processed'
  }
  return 'Refund Request Failed'
}

interface statusbarInterface {
  response: {
    height: number
  }
}

export const KeyboardAwareModal = ({
  visible,
  hideModal,
  label,
  totalAmount,
  status,
  headerText,
  buttonText,
  route,
  txnId = '',
  generateStatus = false,
  handleGenerateQr,
  navigateToSuccess,
  initiateSingleRefund,
  showInvoiceId,
}: KeyboardAwareModalInterface) => {
  // const isFromTransaction = route === Routes.TRANSACTIONS
  const [keyboardHeight] = useKeyboard()
  const [statusBarHeight, setStatusbarHeight] = useState(0)
  const [amount, setAmount] = useState(totalAmount)
  const [error, setError] = useState('')
  const [invoiceError, setInvoiceError] = useState('')
  const [invoiceId, setInvoiceId] = useState('')

  const [initiateRefund, { state, data }] = useLazyApiData(initiateSingleRefund)
  const handleRefund = (): void => {
    initiateRefund(amount, invoiceId)
  }

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      hideModal()
      const statusTxn = data?.data?.data?.status ?? 'FAILED'
      navigateToSuccess(getRefundMessage(statusTxn), Routes.TRANSACTIONS, amount, statusTxn, String(txnId))
    }
  }, [amount, data, hideModal, navigateToSuccess, state, txnId])

  const isInvalidStatus = status !== 'success'
  const isErrorActive = error !== ''
  const isloading = state === 'pending' || generateStatus
  const isDisabled = isButtonDisabled({
    route,
    isErrorActive,
    amount,
    totalAmount,
    isInvalidStatus,
    isloading,
    showInvoiceId,
    invoiceError,
    invoiceId,
  })

  const bottomButton = () => (
    <Box
      {...styles.initiateRefundBox}
      onPress={() => onPress({ route, handleRefund, generateQR })}
      testID={'bottom-btn-' + buttonText}
      opacity={isDisabled ? 0.3 : 1}
      disabled={isDisabled}>
      {isloading ? (
        <Loader color="WHITE" />
      ) : (
        <Text type={'h2'} color="WHITE">
          {buttonText}
        </Text>
      )}
    </Box>
  )

  const generateQR = () => {
    if (handleGenerateQr) {
      handleGenerateQr(String(amount) || '0')
    }
  }

  const getErrorOfRefund = (amt: string) => {
    setAmount(amt)
    if (Number(totalAmount) < Number(amt)) {
      setError('Refund amount can not be more than remaining amount')
    } else {
      setError('')
    }
  }

  const checkErrorOfQr = (amt: string) => {
    setAmount(amt)
  }

  const textField = () => {
    return (
      <TextInput
        label={label}
        onFocusBottomLineColor={isErrorActive ? 'ERROR' : 'BLUE'}
        value={`${amount}`}
        onFocus={() => setError('')}
        onBlur={() => onBlur({ route, getRefundValid, status, totalAmount, amount, setError, isInvalidStatus })}
        inputMode="numeric"
        leftComponent={<Text {...styles.leftRupeeText}>{'₹ '}</Text>}
        onChange={(amt) => onchangeText({ route, getErrorOfRefund, checkErrorOfQr, amt })}
        autoFocus={true}
      />
    )
  }

  const handleOnBlur = () => {
    if (isEmpty(invoiceId)) {
      setInvoiceError('Invoice Id cant be empty')
    }
  }
  return (
    <ModalDialogNew animate={true} type="bottom" show={visible} onDismiss={hideModal} onClose={hideModal}>
      <Animated.View style={styles.boxWrapper(keyboardHeight, statusBarHeight, isIos)}>
        <Box {...styles.closeIcon} onPress={hideModal} testID="hideModal" underlayColor={'TRANSPARENT'}>
          <Icon id={'CLOSE'} size={20} color={'BLUE'} />
        </Box>
        <Spacer size={10} />
        <Text textAlign="center" type="h1Bold">
          {headerText}
        </Text>
        <Spacer size={40} />
        {textField()}
        <Box mt={10} h={20}>
          <Text {...styles.errorText}>{error}</Text>
        </Box>
        <Spacer size={16} />
        <ModBox show={showInvoiceId}>
          <TextInput
            label={'Invoice Id'}
            value={invoiceId}
            onFocus={() => setInvoiceError('')}
            onBlur={() => handleOnBlur()}
            onChange={setInvoiceId}
          />
          <Box mt={10} h={20}>
            <Text {...styles.errorText}>{invoiceError}</Text>
          </Box>
        </ModBox>
        {bottomButton()}
      </Animated.View>
    </ModalDialogNew>
  )
}
